import axios from 'axios'
import { showLoadingToast, closeToast } from 'vant';


export function createRequets(baseURL, responseCode, errorCode) {
    const request = axios.create({
        proxy: {
            protocol: 'http',
            host: '127.0.0.1',
            port: 7890,
        },
        timeout: 1000 * 60,
        baseURL
    })

    request.interceptors.request.use((config) => {
        showLoadingToast({
            message: '...加载中',
            forbidClick: true,
            duration: 0
        });
        return config
    })

    request.interceptors.response.use(
        (res) => {
            closeToast()
            let { data } = res
            if (responseCode && res.data.code == responseCode) {
                data = res.data.data
            }
            return data
        },
        (err) => {
            closeToast()
            console.log(err, '请求出错');
        }
    )

    return request
}

// const api = 'http://baiaocai.top'
const api = '/aaa'
const api1 = '/bbb'
export const drawHttp = createRequets(api, 10000)
export const myHttp = createRequets(api)
export const configHttp = createRequets(api1)
// http://www.baiao.xyz
// /aaa
